// TEAM MEMBERS

document.addEventListener('DOMContentLoaded', _=> {
    // Opens Modal
    if (document.querySelectorAll('.team-member-grid').length > 0) {
        const memberModalLinks = document.querySelectorAll('.team-member-image-overlay')
        if (memberModalLinks != null) {
            memberModalLinks.forEach(link => {
                link.addEventListener('click', (ev) => {
                    showMemberModal(link, document.getElementById(link.getAttribute('data-target')))
                    createSiblingArrows(link, document.getElementById(link.getAttribute('data-target')))
                    const heading = ev.target.dataset.heading;
                    if (heading) {
                        document.querySelector(`#${heading}`).scrollIntoView();
                    } else {
                        // heading is sometimes null randomly
                        document.querySelector('#banner_wrapper').scrollIntoView();
                    }
                })
            })
        }

        function showMemberModal(link, modal) {
            document.querySelectorAll('.member-overlay').forEach(link => {
                if (link.classList.contains('show')) {
                    link.classList.remove('show')
                    link.classList.add('pointer-events-none')
                }
            })
            if (link != null && modal != null) {
                modal.classList.add('show')
                modal.classList.remove('pointer-events-none')
            }
        }


        // Closes Modal with BTN
        const memberModalBackBtns = document.querySelectorAll('.member-modal-back')
        if (memberModalBackBtns != null) {
            memberModalBackBtns.forEach(btn => {
                btn.addEventListener('click', _ => {
                    btn.closest('.member-overlay').classList.remove('show')
                    btn.closest('.member-overlay').classList.add('pointer-events-none')
                })
            })
        }


        // Switches Modal to sibling
        function createSiblingArrows(link, modal) {

            document.querySelectorAll('.member-nav-btn').forEach(btn => {
                btn.outerHTML = btn.outerHTML
            })

            const prevSibling = link.closest('.team-member').previousElementSibling
            const nextSibling = link.closest('.team-member').nextElementSibling

            function clickMemberBtn() {
                if (this.classList.contains('next-member-button')) {
                    nextSibling.querySelector('.team-member-image-overlay').click()
                } else {
                    prevSibling.querySelector('.team-member-image-overlay').click()
                }
            }

            if (prevSibling != null) {
                modal.querySelector('.prev-member-button').classList.remove('d-none')
                modal.querySelector('.prev-member-button').addEventListener('click', clickMemberBtn)
            } else {
                modal.querySelector('.prev-member-button').classList.add('d-none')
            }

            if (nextSibling != null) {
                modal.querySelector('.next-member-button').classList.remove('d-none')
                modal.querySelector('.next-member-button').addEventListener('click', clickMemberBtn)
            } else {
                modal.querySelector('.next-member-button').classList.add('d-none')
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', _ => {
    const productDisplays = document.querySelectorAll('.product-display');
    if (productDisplays.length > 0) {
        productDisplays.forEach(productDisplay => {
            let typingTimer;
            let typeInterval = 100;
        
            const productSearch = productDisplay.querySelector('#productSearch');
            const productGrid = productDisplay.querySelector('.product-grid');
            const products = productGrid.querySelectorAll('.article');
            const noProductsFound = productGrid.querySelector('.no-products-found');

            productSearch.addEventListener('keyup', (ev) => {
                if (ev.target.value.length > 0) {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(searchProducts(productDisplay), typeInterval);
                } else {
                    noProductsFound.classList.add('d-none');
                    noProductsFound.classList.remove('d-flex');
                    products.forEach(product => {
                        product.classList.remove('d-none');
                    });
                }
            });
        })
    }

});

function searchProducts(productDisplay) {
    const productSearch = productDisplay.querySelector('#productSearch');
    const productGrid = productDisplay.querySelector('.product-grid');
    const products = productGrid.querySelectorAll('.article');
    const noProductsFound = productGrid.querySelector('.no-products-found');

    const query = productSearch.value.split(" ");
    
    noProductsFound.classList.add('d-none');
    noProductsFound.classList.remove('d-flex');
    let productsFound = false;

    for (const product of products) {
        if (query.some(v => product.dataset.title.toLowerCase().includes(v.toLowerCase()))
            || query.some(v => product.dataset.author.toLowerCase().includes(v.toLowerCase()))
            || query.some(v => product.dataset.publisher.toLowerCase().includes(v.toLowerCase()))) {
            product.classList.remove('d-none');
            productsFound = true;
        } else {
            product.classList.add('d-none');
        }
    }

    if (!productsFound && productSearch.value !== "") {
        noProductsFound.classList.remove('d-none');
        noProductsFound.classList.add('d-flex');
    }
}